module.exports = __webpack_public_path__ + "public/1.0.1_301066/img/company.6b327e21.jpg";